function initializeSlickCarousel() {
  // Cache DOM queries and layout calculations at the start to prevent forced reflows
  const bodyClasses = document.body.classList;
  const windowWidth = $(window).width();
  const isMobile = windowWidth <= 992;
  const isTablet = windowWidth <= 991;

  // Pre-cache all element selections to avoid repeated DOM queries
  const elements = {
    pdpFeaturedSlider: $(".pdp-featured-collection .slider"),
    pdpReviewContainer: $(".pdp-review-container"),
    doctorsReviewContainer: $(".doctors-review-container"),
    productCarouselContainer: $(".product-carousel .carousel-container"),
    upsellCarousel: $(".upsell-carousel"),
    imageCarouselContainer: $(".image-carousel-container"),
    ingredientsParent: $(".ingredients-parent"),
    customerReviewsContainer: $(".customer-reviews-container"),
    timelineMobileSlider: $(".timeline-mobile .slider"),
    itemMobileTimeline: $(".item-mobile-timeline"),
    telehealthReviews: $(".telehealth-reviews-socials"),
    ugcVideo: $(".ugc-video-section:not(.menopause_template):not(.ugc-video-section--block) .ugc-video"),
    ugcVideoMenopause: $(".ugc-video-section.menopause_template .ugc-video"),
    appLightingGrid: $(".app-lighting-grid .image-grid-container"),
    skinWellnessItems: $(".skin-wellness .wellness-items"),
    reviewWithRatings: $(".review-with-ratings-container"),
    masterClassHost: $(".master-class-host-details"),
    doctorQuoteSlider: $(".doctor-quote-slider .doctor-quote-slider-wrapper"),
    heroHomeBanner: $(".hero-slick-slider"),
    xmasSlider: $(".xmas-slider .carousel"),
    ddReviewSlider: $(".compare-slide-container--dd"),
    ddNavSlider: $(".slider-nav-compare-slide-container-dd"),
    ingredientsSlider: $(".ingredients-slider"),
    eventsPastCarousel: $("[data-past-events-carousel]"),
    eventsTestimonialsCarousel: $("[data-testimonials-carousel]"),
    storeCarouselSlider: $(".store-carousel-slider"),
  };

  // Shared configurations to avoid repetition
  const commonArrows = {
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
  };

  const svgArrows = {
    prevArrow:
      '<button type="button" class="slick-prev svg-btn"><svg class="arr-svg" width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next svg-btn"><svg class="arr-svg" width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
  };

  const customDDArrows = {
    prevArrow:
      '<button type="button" class="slick-prev custom-dd-arrows"><svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.94043 0.345016L0.690429 9.00527L8.94043 17.6655" stroke="black"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next custom-dd-arrows"><svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.361816 0.345016L8.61182 9.00527L0.361815 17.6655" stroke="black"/></svg></button>',
  };

  // Pre-cache DD doctor quote slider
  const ddDoctorQuoteSlider = $(".doctor-quote-slider-wrapper-ddd");

  // PDP Featured Collection Slider
  if (
    (bodyClasses.contains("index") ||
      bodyClasses.contains("product") ||
      bodyClasses.contains("our-story") ||
      bodyClasses.contains("our-science") ||
      bodyClasses.contains("clinical-study") ||
      bodyClasses.contains("our-sustainability") ||
      bodyClasses.contains("account") ||
      bodyClasses.contains("order") ||
      bodyClasses.contains("page") ||
      bodyClasses.contains("hdlStory") ||
      bodyClasses.contains("cart")) &&
    elements.pdpFeaturedSlider.length > 0
  ) {
    const totalItems = elements.pdpFeaturedSlider.children().length;

    if (isMobile) {
      // Mobile: always initialize
      elements.pdpFeaturedSlider.slick({
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: false,
        centerMode: false,
        accessibility: false,
      });
    } else if (totalItems > 4) {
      // Desktop: initialize only if more than 4 items
      elements.pdpFeaturedSlider.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        centerMode: false,
        accessibility: false,
        ...commonArrows,
      });
    }
  }

  // PDP Review Container
  if (
    bodyClasses.contains("product") &&
    elements.pdpReviewContainer.length > 0
  ) {
    elements.pdpReviewContainer.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: false,
      centerMode: false,
      accessibility: false,
    });
  }

  // Doctors Review Container
  if (
    bodyClasses.contains("product") &&
    elements.doctorsReviewContainer.length > 0
  ) {
    elements.doctorsReviewContainer.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      arrows: false,
      dots: true,
      centerMode: false,
      accessibility: false,
    });
  }

  // Product Carousel
  if (
    (bodyClasses.contains("product") ||
      bodyClasses.contains("retargeting-users")) &&
    elements.productCarouselContainer.length > 0
  ) {
    elements.productCarouselContainer.slick({
      infinite: false,
      slidesToShow: 4.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      ...commonArrows,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.2,
            centerMode: false,
          },
        },
      ],
    });
  }

  if (bodyClasses.contains("index")) {
    const heroSlider = elements.heroHomeBanner;

    let autoplayStopped = false;

    heroSlider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 10000,
    });

    heroSlider.on("afterChange", function (event, slick, currentSlide) {
      if (!autoplayStopped && currentSlide === slick.slideCount - 1) {
        heroSlider.slick("slickPause");
        autoplayStopped = true;
      }
    });
  }

  const xmasSlider = elements.xmasSlider;

  xmasSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 2,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Cart upsell section
  if (!bodyClasses.contains("product") && elements.upsellCarousel.length > 0) {
    elements.upsellCarousel.slick({
      infinite: false,
      arrows: true,
      dots: false,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: false,
      customPaging: function (slider, index) {
        return (
          '<button type="button" class="slick-dot">' + (index + 1) + "</button>"
        );
      },
      ...commonArrows,
    });
  }

  //Our story
  if (
    bodyClasses.contains("our-story") &&
    elements.imageCarouselContainer.length > 0
  ) {
    elements.imageCarouselContainer.slick({
      infinite: false,
      slidesToShow: 2.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      centerMode: false,
      accessibility: false,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 1.8,
          },
        },

        {
          breakpoint: 452,
          settings: {
            slidesToShow: 1.2,
          },
        },
      ],
    });
  }

  //Blog Ingredients
  if (
    isMobile &&
    bodyClasses.contains("article") &&
    elements.ingredientsParent.length > 0
  ) {
    elements.ingredientsParent.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: true,
      centerPadding: "10px",
      infinite: false,
      arrows: true,
      accessibility: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  //Collections
  if (
    bodyClasses.contains("collection") &&
    elements.customerReviewsContainer.length > 0
  ) {
    elements.customerReviewsContainer.slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      customPaging: function (slider, index) {
        return (
          '<button type="button" class="slick-dot">' + (index + 1) + "</button>"
        );
      },
      ...svgArrows,

      responsive: [
        {
          breakpoint: 991, // Breakpoint at 1200px
          settings: {
            slidesToShow: 1, // Show 1 slide instead of 2
          },
        },
        {
          breakpoint: 601, // Breakpoint at 1200px
          settings: {
            slidesToShow: 1.1, // Show 1 slide instead of 2
          },
        },
      ],
    });
  }

  //App Timeline
  if (
    (bodyClasses.contains("app") ||
      bodyClasses.contains("wellness") ||
      bodyClasses.contains("supplement-product") ||
      bodyClasses.contains("sleepRecoveryScalpElixirS2")) &&
    elements.timelineMobileSlider.length > 0
  ) {
    elements.timelineMobileSlider.slick({
      infinite: false,
      arrows: false,
      dots: false,
      autoplay: false,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      accessibility: false,
    });

    elements.timelineMobileSlider.on(
      "afterChange",
      function (event, slick, currentSlide) {
        elements.itemMobileTimeline.removeClass("active");
        elements.itemMobileTimeline.eq(currentSlide).addClass("active");

        // Toggle image display based on active state
        toggleImage(currentSlide);
      }
    );

    elements.itemMobileTimeline.click(function () {
      let index = $(this).index();
      elements.timelineMobileSlider.slick("slickGoTo", index);
    });

    elements.timelineMobileSlider.slick("slickGoTo", 0);
  }

  // Telehealth Reviews
  if (
    (bodyClasses.contains("product")) &&
    elements.telehealthReviews.length > 0
  ) {
    elements.telehealthReviews.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: false,
      centerMode: false,
      accessibility: false,
    });
  }

  // UGC Video
  if (
    (bodyClasses.contains("index") ||
      bodyClasses.contains("product") ||
      bodyClasses.contains("ultimate-comparison") ||
      bodyClasses.contains("investment") ||
      bodyClasses.contains("summer-promo")) &&
    isMobile &&
    elements.ugcVideo.length > 0
  ) {
    elements.ugcVideo.slick({
      infinite: false,
      slidesToShow: 2.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      centerMode: false,
      swipeToSlide: true,
      accessibility: false, // Disable the problematic ADA functionality
    });
  }

  // UGC Video — menopause template (slider on desktop + mobile)
  if (elements.ugcVideoMenopause.length > 0) {
    elements.ugcVideoMenopause.slick({
      infinite: false,
      slidesToShow: 5.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      centerMode: false,
      swipeToSlide: true,
      accessibility: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4.2,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "18%",
            dots: true,
          },
        },
      ],
    });
  }

  // App Lighting Grid
  if (
    isTablet &&
    bodyClasses.contains("sleepRecoveryDeStress") &&
    elements.appLightingGrid.length > 0
  ) {
    elements.appLightingGrid.slick({
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      customPaging: function (slider, index) {
        return (
          '<button type="button" class="slick-dot">' + (index + 1) + "</button>"
        );
      },
      ...commonArrows,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.5,
            centerMode: false,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1.2,
            centerMode: false,
          },
        },
      ],
    });
  }

  // Skin Wellness Items
  if (
    isTablet &&
    bodyClasses.contains("product") &&
    elements.skinWellnessItems.length > 0
  ) {
    elements.skinWellnessItems.slick({
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      customPaging: function (slider, index) {
        return `<button type="button" class="slick-dot">${index + 1}</button>`;
      },
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.5,
            centerMode: false,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1.2,
            centerMode: false,
          },
        },
      ],
    });
  }

  // Review with Ratings Container
  if (
    (bodyClasses.contains("yoga-master-class") ||
      bodyClasses.contains("master-class")) &&
    elements.reviewWithRatings.length > 0
  ) {
    elements.reviewWithRatings.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      dots: true,
      centerPadding: "10px",
      infinite: false,
      arrows: false,
      accessibility: false,
      customPaging: function (slider, i) {
        return '<div class="custom-dot"></div>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
          },
        },
      ],
    });
  }

  // Master Class Host Details
  if (
    isMobile &&
    bodyClasses.contains("master-class") &&
    elements.masterClassHost.length > 0
  ) {
    elements.masterClassHost.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      centerPadding: "10px",
      infinite: false,
      arrows: false,
      accessibility: false,
      customPaging: function (slider, i) {
        return '<div class="custom-dot"></div>';
      },
    });
  }

  // Doctor Quote Slider
  if (
    bodyClasses.contains("reviews") &&
    elements.doctorQuoteSlider.length > 0
  ) {
    elements.doctorQuoteSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      centerPadding: "10px",
      infinite: false,
      arrows: true,
      accessibility: false,
      ...commonArrows,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // DD Review After Before Slider
  if (elements.ddReviewSlider.length > 0) {
    var $ddNavThumbs = elements.ddNavSlider.find('.compare__slide');

    // Mark first thumbnail as active
    $ddNavThumbs.first().addClass('active');

    if (isMobile) {
      // Mobile: single-slide carousel with thumbnail tabs above
      elements.ddReviewSlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        centerMode: false,
        swipeToSlide: true,
        draggable: true,
        swipe: true,
        touchThreshold: 10,
        accessibility: false,
        ...customDDArrows,
      });

      // Nav thumbs - show 3 at a time with active centered, looping
      var totalThumbs = $ddNavThumbs.length;

      function updateVisibleThumbs(activeIndex) {
        // Hide all thumbs first
        $ddNavThumbs.hide();
        $ddNavThumbs.removeClass('active');

        // Calculate prev, active, next indices with wrapping
        var prevIndex = (activeIndex - 1 + totalThumbs) % totalThumbs;
        var nextIndex = (activeIndex + 1) % totalThumbs;

        // Show only the 3 visible thumbs and mark active
        $ddNavThumbs.eq(prevIndex).show();
        $ddNavThumbs.eq(activeIndex).show().addClass('active');
        $ddNavThumbs.eq(nextIndex).show();
      }

      // Initial state - show first 3 with first active
      updateVisibleThumbs(0);

      // Handle thumbnail clicks - navigate to respective slide
      $ddNavThumbs.on('click', function () {
        var slideIndex = $(this).index();
        if (elements.ddReviewSlider.hasClass('slick-initialized')) {
          elements.ddReviewSlider.slick('slickGoTo', slideIndex);
        }
      });

      // Update visible thumbs on slide change
      elements.ddReviewSlider.on('afterChange', function (event, slick, currentSlide) {
        updateVisibleThumbs(currentSlide);
      });
    } else {
      // Desktop: infinite slider with custom arrows
      elements.ddReviewSlider.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        centerMode: false,
        accessibility: false,
        ...customDDArrows,
      });

      // Handle thumbnail clicks - navigate to respective slide (desktop)
      $ddNavThumbs.on('click', function () {
        var slideIndex = $(this).index();
        if (elements.ddReviewSlider.hasClass('slick-initialized')) {
          elements.ddReviewSlider.slick('slickGoTo', slideIndex);
        }
      });

      // Update active thumbnail on slide change (desktop)
      elements.ddReviewSlider.on('afterChange', function (event, slick, currentSlide) {
        $ddNavThumbs.removeClass('active');
        $ddNavThumbs.eq(currentSlide).addClass('active');
      });
    }
  }

  if (ddDoctorQuoteSlider.length > 0) {
    var ddSlidesToShow = windowWidth >= 1025 ? 2.2 : 1;
    ddDoctorQuoteSlider.slick({
      infinite: false,
      slidesToShow: ddSlidesToShow,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      accessibility: false,
      ...customDDArrows,
    });
  }

  // Events Testimonials Carousel
  if (elements.eventsTestimonialsCarousel.length > 0) {
    elements.eventsTestimonialsCarousel.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      ...commonArrows,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 1,
            infinite: true,
          },
        },
      ],
    });
  }

  // Past Events Carousel - mobile only
  if (isMobile && elements.eventsPastCarousel.length > 0) {
    elements.eventsPastCarousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      ...commonArrows,
    });
  }

  // How To Use Slider - Mobile only (desktop shows all slides with flex)
  const howToUseSliders = $(".how-to-use-slider");

  if (howToUseSliders.length > 0 && isMobile) {
    howToUseSliders.each(function () {
      const $slider = $(this);
      const sectionId = $slider.data('section-id');
      const $container = $slider.closest('.how-to-use-container');
      const $tabs = $container.find('.tab-link');
      const isMenopause = $slider.data('menopause-slider') === true || $slider.attr('data-menopause-slider') === 'true';

      // Check if slider has slides before initializing
      if ($slider.find('.use-slide').length === 0) {
        return;
      }

      // Check if already initialized
      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      // Initialize slick slider for mobile only
      $slider.slick({
        infinite: false,
        slidesToShow: isMenopause ? 1.15 : 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        accessibility: false,
        adaptiveHeight: true,
        ...customDDArrows,
      });

      // Handle tab clicks - navigate to respective slide
      $tabs.off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const slideIndex = parseInt($(this).data('slide-index'));
        if (!isNaN(slideIndex) && $slider.hasClass('slick-initialized')) {
          $slider.slick('slickGoTo', slideIndex);
        }
      });

      // Update active tab on slide change
      $slider.on('afterChange', function (event, slick, currentSlide) {
        $tabs.removeClass('active');
        $tabs.eq(currentSlide).addClass('active');

        // Center the active tab by scrolling only the tabs strip.
        // scrollIntoView (even with block:'nearest') also scrolls the page
        // vertically, which caused an auto-scroll on page load.
        const activeTab = $tabs.eq(currentSlide)[0];
        if (activeTab && activeTab.parentElement) {
          const tabsContainer = activeTab.parentElement;
          tabsContainer.scrollTo({
            left: activeTab.offsetLeft - (tabsContainer.clientWidth - activeTab.clientWidth) / 2,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Ingredients Slider - Mobile only with center mode
  if (isMobile && elements.ingredientsSlider.length > 0) {
    const slideCount = elements.ingredientsSlider.children('.ingredient-card').length;

    // Only initialize if there are slides
    if (slideCount === 0) {
      return;
    }

    // Check if slider is already initialized, if so destroy it first
    if (elements.ingredientsSlider.hasClass('slick-initialized')) {
      elements.ingredientsSlider.slick('unslick');
    }

    // Use infinite only if there are more than 1 slides
    const useInfinite = slideCount > 1;

    elements.ingredientsSlider.slick({
      dots: false,
      infinite: useInfinite,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      arrows: true,
      centerMode: true,
      centerPadding: '60px',
      accessibility: false,
      ...customDDArrows,
    });

    // Wait for slider to be fully initialized
    setTimeout(function () {
      const $ingredientDots = $('.ingredient-dot');

      // Handle dot clicks - navigate to respective slide
      $ingredientDots.off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const slideIndex = parseInt($(this).data('slide-index'));

        if (!isNaN(slideIndex) && elements.ingredientsSlider.hasClass('slick-initialized')) {
          // Navigate to the slide
          try {
            elements.ingredientsSlider.slick('slickGoTo', slideIndex);
          } catch (error) {
            console.error('Error navigating to slide:', error);
          }
        }
      });

      // Update active dot on slide change
      elements.ingredientsSlider.off('afterChange').on('afterChange', function (event, slick, currentSlide) {
        $ingredientDots.removeClass('active');
        $ingredientDots.eq(currentSlide).addClass('active');
      });

      // Set initial active dot
      $ingredientDots.removeClass('active');
      $ingredientDots.eq(0).addClass('active');
    }, 200);
  }

  // Store Carousel Slider
  if (elements.storeCarouselSlider.length > 0) {
    elements.storeCarouselSlider.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      ...commonArrows,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (typeof initializeSlickCarousel === "function") {
    initializeSlickCarousel();
  }
});

// Growth Circle Community — mobile-only slider
(function () {
  var MOBILE_BREAKPOINT = 768;
  var sliderInitialized = false;

  function initCommunitySlider() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var $photos = $('.growth-circle-community-photos');
    if (!$photos.length || sliderInitialized) return;

    $photos.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
    });

    sliderInitialized = true;
  }

  function destroyCommunitySlider() {
    var $photos = $('.growth-circle-community-photos');
    if (!$photos.length || !sliderInitialized) return;
    if ($photos.hasClass('slick-initialized')) $photos.slick('unslick');
    sliderInitialized = false;
  }

  function onCommunityResize() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      destroyCommunitySlider();
    } else {
      initCommunitySlider();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCommunitySlider();
    window.addEventListener('resize', onCommunityResize);
  });
})();


// Growth Circle Redeem — gifts & vouchers mobile-only sliders
(function () {
  var MOBILE_BREAKPOINT = 768;
  var giftsInitialized = false;
  var vouchersInitialized = false;

  var commonSlickArrows = {
    prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
  };

  function initGiftsSlider() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var $grid = $('.growth-circle-gifts-grid');
    if (!$grid.length || giftsInitialized) return;
    $grid.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: true,
    });
    giftsInitialized = true;
  }

  function destroyGiftsSlider() {
    var $grid = $('.growth-circle-gifts-grid');
    if (!$grid.length || !giftsInitialized) return;
    if ($grid.hasClass('slick-initialized')) $grid.slick('unslick');
    giftsInitialized = false;
  }

  function initVouchersSlider() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var $grid = $('.growth-circle-vouchers-grid');
    if (!$grid.length || vouchersInitialized) return;
    $grid.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      ...commonSlickArrows,
    });
    vouchersInitialized = true;
  }

  function destroyVouchersSlider() {
    var $grid = $('.growth-circle-vouchers-grid');
    if (!$grid.length || !vouchersInitialized) return;
    if ($grid.hasClass('slick-initialized')) $grid.slick('unslick');
    vouchersInitialized = false;
  }

  function onRedeemResize() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      destroyGiftsSlider();
      destroyVouchersSlider();
    } else {
      initGiftsSlider();
      initVouchersSlider();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGiftsSlider();
    initVouchersSlider();
    window.addEventListener('resize', onRedeemResize);
  });
})();

// Growth Circle Earn Points — milestone mobile-only slider
(function () {
  var MOBILE_BREAKPOINT = 768;
  var sliderInitialized = false;

  function initMilestoneSlider() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var $row = $('.growth-circle-milestones-row');
    if (!$row.length || sliderInitialized) return;

    $row.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
    });

    sliderInitialized = true;
  }

  function destroyMilestoneSlider() {
    var $row = $('.growth-circle-milestones-row');
    if (!$row.length || !sliderInitialized) return;
    if ($row.hasClass('slick-initialized')) $row.slick('unslick');
    sliderInitialized = false;
  }

  function onMilestoneResize() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      destroyMilestoneSlider();
    } else {
      initMilestoneSlider();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMilestoneSlider();
    window.addEventListener('resize', onMilestoneResize);
  });
})();

// Growth Circle Testimonials — mobile-only slider
(function () {
  var MOBILE_BREAKPOINT = 768;
  var sliderInitialized = false;

  function initGcTestimonialsSlider() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var $grid = $('.growth-circle-testimonials-grid');
    if (!$grid.length || sliderInitialized) return;

    $grid.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
    });

    sliderInitialized = true;
  }

  function destroyGcTestimonialsSlider() {
    var $grid = $('.growth-circle-testimonials-grid');
    if (!$grid.length || !sliderInitialized) return;
    if ($grid.hasClass('slick-initialized')) $grid.slick('unslick');
    sliderInitialized = false;
  }

  function onGcTestimonialsResize() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      destroyGcTestimonialsSlider();
    } else {
      initGcTestimonialsSlider();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGcTestimonialsSlider();
    window.addEventListener('resize', onGcTestimonialsResize);
  });
})();

(function () {
  var PREV_SVG =
    '<svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0 0h48v48H0z" fill="none"/><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></svg>';
  var NEXT_SVG =
    '<svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0 0h48v48H0z" fill="none"/><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></svg>';

  function setupEventsPastCarousel() {
    var $grid = $('[data-past-events-carousel]');
    if (!$grid.length || $grid.data('events-past-init')) return;
    $grid.data('events-past-init', true);

    var $container = $grid.parent('.events-past__container');
    if (!$container.length) $container = $grid.parent();

    var $prev = $(
      '<button type="button" class="events-past__arrow events-past__arrow--prev" aria-label="Previous events">' +
        PREV_SVG +
        '</button>'
    );
    var $next = $(
      '<button type="button" class="events-past__arrow events-past__arrow--next" aria-label="Next events">' +
        NEXT_SVG +
        '</button>'
    );
    $container.append($prev).append($next);

    function getStep() {
      var $card = $grid.find('.events-past__card').first();
      if (!$card.length) return $grid[0].clientWidth;
      var gap = parseInt($grid.css('column-gap') || $grid.css('gap'), 10) || 0;
      return $card.outerWidth() + gap;
    }

    $prev.on('click', function () {
      $grid[0].scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    $next.on('click', function () {
      $grid[0].scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    function updateArrows() {
      var el = $grid[0];
      var maxScroll = el.scrollWidth - el.clientWidth;
      $prev.removeAttr('hidden');
      $next.removeAttr('hidden');
      if (maxScroll <= 1) {
        $prev.prop('disabled', true);
        $next.prop('disabled', true);
        return;
      }
      $prev.prop('disabled', el.scrollLeft <= 1);
      $next.prop('disabled', el.scrollLeft >= maxScroll - 1);
    }

    $grid.on('scroll', updateArrows);
    $(window).on('resize orientationchange', updateArrows);
    updateArrows();
  }

  document.addEventListener('DOMContentLoaded', setupEventsPastCarousel);
  $(window).on('load', setupEventsPastCarousel);
})();
